import script from "./TarifPriceInput.vue?vue&type=script&lang=ts&setup=true"
export * from "./TarifPriceInput.vue?vue&type=script&lang=ts&setup=true"

import "./TarifPriceInput.vue?vue&type=style&index=0&id=5e739e40&lang=scss"

const __exports__ = script;

export default __exports__